import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Sc4FailedMessagesListState, Sc4FailedMessagesListStateModel } from './sc4-failed-messages-list.state';
import { Sc4FailedMessagesModel, Sc4FailedMessagesListSearchCriteria } from '../../models';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../../list-search-criteria';
import { Sc4FailedMessagesListInitialState, Sc4FailedMessagesListLoad } from './sc4-failed-messages-list.actions';
import { FailedMessagesListFacadeInterface } from '../../models/failed-messages-facades.model';

@Injectable({ providedIn: 'root' })
export class Sc4FailedMessagesListFacade implements FailedMessagesListFacadeInterface<Sc4FailedMessagesModel> {
  listDto$: Observable<Sc4FailedMessagesListStateModel> = this.store.select(Sc4FailedMessagesListState.getState);
  items$: Observable<Sc4FailedMessagesModel[]> = this.store.select(Sc4FailedMessagesListState.getItems);
  totalElements$: Observable<number> = this.store.select(Sc4FailedMessagesListState.getTotalElements);
  loaded$: Observable<boolean> = this.store.select(Sc4FailedMessagesListState.getLoaded);

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.Sc4FailedMessages)
      .subscribe((searchCriteria: Sc4FailedMessagesListSearchCriteria) => {
        this.store.dispatch(new Sc4FailedMessagesListLoad(searchCriteria));
      });
  }

  setInitialState(): void {
    this.store.dispatch(new Sc4FailedMessagesListInitialState());
  }
}
